import React from 'react';
import { bool, shape, string } from 'prop-types';

const Spreading = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6 12C6 10.9 6.4002 9.89961 7.2002 9.09961L8.2998 8.09961C7.99997 7.79958 7.7998 7.29964 7.7998 6.7998L7.7998 4C7.7998 2.90006 8.69989 2.00011 9.7998 2L14.2002 2C15.3001 2.00011 16.2002 2.90007 16.2002 4V6.7998C16.2002 7.29964 16 7.79958 15.7002 8.09961L16.7998 9.09961C17.5498 9.8496 17.9482 10.7757 17.9951 11.7949L18 12V19.2998C18 20.7998 16.7998 22 15.2998 22H8.7002C7.2002 22 6 20.7998 6 19.2998L6 12ZM8 19.2998C8 19.6998 8.3002 20 8.7002 20H15.2998C15.6998 20 16 19.6998 16 19.2998V18H11V12H16C16 11.5 15.8004 10.9996 15.4004 10.5996L13.7998 9.09961L13.7002 9H10.2998L10.2002 9.09961L8.59961 10.5996C8.19961 10.9996 8 11.5 8 12V19.2998ZM16 16V14H13V16H16ZM14.2002 7V4H9.7998V7H14.2002Z" fill="currentColor" />
  </svg>
);

Spreading.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Spreading;
